import React, { Component } from "react";
//import HardwareTicketDataService from "../services/hardware-ticket-activities";
import NewsAndPatchNotesDataService from "../services/news-and-patch-note-activities";
import { Redirect } from "react-router-dom";

import baseEndpoint from "../news-and-patch-notes-endpoint";

import { connect } from 'react-redux';
import { LOGOUT } from '../features/actions/Is-Logged-Actions';

//import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Navbar from '../components/Navbar';

import { cleanHTML } from '../html-cleaner';
import parse from 'html-react-parser';

//import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
//import Button from 'react-bootstrap/Button';

import {
    //ScrollArea,
    //UnstyledButton,
    //Group,
    Text,
    Button,
    //Center,
    TextInput,
    //Table,
    //rem,
    Modal,
    //keys,
    Paper,
    Select,
    Title,
    //Grid,
    //Flex,
} from '@mantine/core';
import { DateInput } from '@mantine/dates';
import RichTextInput from './RichTextInput';
import { IconTrash } from "@tabler/icons-react";

import { setLastSeenNewsId } from '../utils/cookieUtils.ts';
import productName from "../product-name";

//import { Link } from 'react-router-dom';

//import RequesterSelector from './Ticket-Requester-Selector';

//import oneDriveConfig from "../onedrive-info";
//import * as msal from "@azure/msal-browser";

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faTimes } from "@fortawesome/free-solid-svg-icons";

//import MAX_ATTACHMENT_SIZE from "../max-attachment-size";

//import onedriveAxios from "../onedrive-axios";

//import { UPDATE_ACTIVE_REQUESTER, REQUESTER_CHANGE_RESOLVED } from '../features/actions/Ticket-Requester-Actions';
//import { removeTags } from "../remove-html-tags";


class NewsAndPatchNotes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            startDateSelected: null,
            endDateSelected: null,
            productToSaveUnder: `${productName}`,     // the product the created note will be saved under - this is only needed on the deployment within Cumulus
            productIdSave: 0,       // id number corresponding to the string value in product to save under
            productToDisplay: `${productName}`,        // CHANGE THIS DEPENDING ON PRODUCT THIS PAGE IS DEPLOYED WITHIN (we have the ablity to change, but normal users do not - they'll just see notes for the current product they are using)
            productIdDisplay: 0,    // id number corresponding to the string value in product to display
            products: [],       // list of ProGroup software and their id numbers
            notes: [],       // will contain the detail returned from the API endpoint
            show_create_news_item_modal: false,
            show_edit_news_item_modal: false,
            show_delete_news_modal: false,


            typeChosenInCreateForm: "News",
            titleEnteredInCreateForm: "",
            bodyEnteredInCreateForm: "",

            canSeeErrorMessageCreateNewsItem: false,

            // the items below are for the edit form
            productNameToEdit: "",
            productIdToEdit: 0,
            typeChosenInEditForm: "",
            titleEnteredInEditForm: "",
            bodyEnteredInEditForm: "",
            noteIdToEdit: 0
        }
    }

    // returns date strings YYYY-MM-DD start date = first day of previous month to current, end date = current date
    getExpandedMonthDateRange() {
        const now = new Date();

        // First day of the previous month
        const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);

        // Helper to format date as YYYY-MM-DD
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            startDate: formatDate(start).toString(),
            endDate: formatDate(now).toString()
        };
    }

    formatDateToString(date) {
        console.log("Date in formatDateToString: ", date);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    // calls the backend API for a list of ProGroup software and their id numbers
    getProGroupProducts() {
        return new Promise ((resolve, reject) => {
            fetch(`${baseEndpoint}/getProGroupProducts`, {
                method: 'GET',
                mode: 'cors'
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return response.json();
            })
            .then(data => {
                console.log("Product data received: ", data);
                // find the product id that matches the string we have selected in the component state
                const matchingProduct = data.results.find(product => product.product_name === this.state.productToDisplay);

                this.setState({
                    products: data.results,
                    productIdDisplay: matchingProduct.id
                }, () => {
                    resolve();
                });
            })
            .catch(error => {
                console.log('Fetch error: ', error);
                reject();
            });
        })
    }

    // calls the backend API for notes based on specified parameters
    getNotes() {
        fetch(`${baseEndpoint}/getNewsAndPatchNotes?product=${this.state.productIdDisplay}&startDate=${this.formatDateToString(this.state.startDateSelected)}&endDate=${this.formatDateToString(this.state.endDateSelected)}`, {
            method: 'GET',
            mode: 'cors'
        }).then(response => {
            console.log('Response received: ', response);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            return response.json(); // parse JSON body
        })
        .then(data => {
            console.log('Data received: ', data);
            this.setState({
                notes: data.results
            }, () => {
                if(this.state.productToDisplay === productName) {
                    console.log("Going to update last seen news id");
                    // if they are viewing the product in question, we need to update their max id seen and the status of the show dot
                    // the latest news item will be in position 0 of the notes array
                    if(this.state.notes.length > 0) {
                        console.log("Inside final conditional block before updating");
                        setLastSeenNewsId(this.state.notes[0].id);
                    }
                }
            });
        })
        .catch(error => {
            console.log('Fetch error: ', error);
        });
    }

    componentDidMount() {
        if (this.props.loggedStatus.loggedIn) {
            
            const { startDate, endDate } = this.getExpandedMonthDateRange();
            console.log(startDate, endDate);
            let startDatePieces = startDate.split("-");
            let endDatePieces = endDate.split("-");

            this.setState({
                startDateSelected: new Date(parseInt(startDatePieces[0]), parseInt(startDatePieces[1]) - 1, parseInt(startDatePieces[2])),      // the - 1 was needed on the montn piece as months are 0 indexed in Javascript
                endDateSelected: new Date(parseInt(endDatePieces[0]), parseInt(endDatePieces[1]) - 1, parseInt(endDatePieces[2]))
            }, () => {
                this.getProGroupProducts().then(response => {
                    this.getNotes();
                })
                .catch(error => {
                    console.log("Error in component did mount: ", error);
                });
            });  
                
            
        }
    }

    submitNewItem() {
        if(this.state.bodyEnteredInCreateForm === "" || this.state.productIdSave === undefined || this.state.titleEnteredInCreateForm === "" || this.state.typeChosenInCreateForm === "") {
            this.setState({
                canSeeErrorMessageCreateNewsItem: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateNewsItem: false
            });

                console.log("Going to send the following request body");

                let dataObj = {
                    noteText: this.state.bodyEnteredInCreateForm, 
                    userId: this.props.loggedStatus.id, 
                    product: this.state.productIdSave, 
                    title: this.state.titleEnteredInCreateForm, 
                    type: this.state.typeChosenInCreateForm
                }

                console.log(dataObj);



                NewsAndPatchNotesDataService.createNewsItem(dataObj).then(response => {
                    console.log("Response from create news endpoint: ", response);
                    this.getNotes();
                    this.closeCreateNewsItemModal();
                });

       
        }
    }

    openCreateNewsItemModal() {
        // get a value for the productIdSave
        const matchingProduct = this.state.products.find(product => product.product_name === this.state.productToSaveUnder);
        this.setState({
            show_create_news_item_modal: true,
            productIdSave: matchingProduct.id
        });
    }


    closeCreateNewsItemModal() {
        this.setState({
            bodyEnteredInCreateForm: "", 
            //productIdSave: 0, 
            //productToSaveUnder: "Cumulus",      // this default value will depend on the service this code lives in
            titleEnteredInCreateForm: "", 
            //typeChosenInCreateForm: "News",
            show_create_news_item_modal: false
        });
    }

    openEditNewsItemModal(note_id, product_id, type, title, body) {
        // find the product name that matches to 
        const matchingProduct = this.state.products.find(product => product.id === product_id)
        
        this.setState({
            productNameToEdit: matchingProduct.product_name,
            productIdToEdit: product_id,
            typeChosenInEditForm: type,
            titleEnteredInEditForm: title,
            bodyEnteredInEditForm: body,
            noteIdToEdit: note_id,
            show_edit_news_item_modal: true
        });
    }

    closeEditNewsItemModal() {
        this.setState({
            productNameToEdit: "",
            productIdToEdit: 0,
            typeChosenInEditForm: "",
            titleEnteredInEditForm: "",
            bodyEnteredInEditForm: "",
            noteIdToEdit: 0,
            show_edit_news_item_modal: false
        });
    }

    openDeleteNewsModal() {
        this.setState({
            show_delete_news_modal: true
        });
    }

    closeDeleteNewsModal() {
        this.setState({
            show_delete_news_modal: false
        });
    }

    deleteNewsItem() {
            NewsAndPatchNotesDataService.deleteNewsItem( this.state.noteIdToEdit).then(response => {
                console.log("Response from delete backend: ", response);

                // close the delete modal as well as the edit modal
                this.closeDeleteNewsModal();
                this.closeEditNewsItemModal();
                this.getNotes();
            })
            .catch(e => {
                console.log(e);
            });
    }

    submitEditItem() {
        if(this.state.bodyEnteredInEditForm === "" || this.state.productIdToEdit === undefined || this.state.titleEnteredInEditForm === "" || this.state.typeChosenInEditForm === "") {
            this.setState({
                canSeeErrorMessageCreateNewsItem: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateNewsItem: false
            });

                console.log("Going to send the following request body");
        

                let dataObj = {
                    noteText: this.state.bodyEnteredInEditForm, 
                    userId: this.props.loggedStatus.id, 
                    product: this.state.productIdToEdit, 
                    title: this.state.titleEnteredInEditForm, 
                    type: this.state.typeChosenInEditForm,
                    noteId: this.state.noteIdToEdit
                }

                console.log(dataObj);

                NewsAndPatchNotesDataService.editNewsItem( dataObj).then(response => {
                    console.log("Response from edit endpoint: ", response);
                    this.getNotes();
                    this.closeEditNewsItemModal();
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }

    handleStartDateChange(selected_date) {
        let dateToUse;
        
        if(selected_date === null) {
            dateToUse = "";
        }
        
        else {
            dateToUse = selected_date;
        }

        this.setState({
            startDateSelected: dateToUse
        }, () => this.getNotes());
    }

    handleEndDateChange(selected_date) {
        let dateToUse;
        
        if(selected_date === null) {
            dateToUse = "";
        }
        
        else {
            dateToUse = selected_date;
        }

        this.setState({
            endDateSelected: dateToUse
        }, () => this.getNotes());
    }

    handleProductChange(new_product) {
        // find the product id that matches the string we have selected in the component state
        const matchingProduct = this.state.products.find(product => product.product_name === new_product);
        this.setState({
            productToDisplay: new_product,
            productIdDisplay: matchingProduct.id
        }, () => this.getNotes());
    }

    handleProductToSaveChange(new_product) {
        // find the product id that matches the string we have selected in the component state
        const matchingProduct = this.state.products.find(product => product.product_name === new_product);
        this.setState({
            productToSaveUnder: new_product,
            productIdSave: matchingProduct.id
        });
    }

    handleProductToEditChange(new_product) {
        // find the product id that matches the string we have selected in the component state
        const matchingProduct = this.state.products.find(product => product.product_name === new_product);
        this.setState({
            productNameToEdit: new_product,
            productIdToEdit: matchingProduct.id
        });
    }

    handleNewsCreateTypeChange(new_type) {
        this.setState({
            typeChosenInCreateForm: new_type
        });
    }

    handleNewsEditTypeChange(new_type) {
        this.setState({
            typeChosenInEditForm: new_type
        });
    }

    handleNewsCreateTitleChange(e) {
        this.setState({
            titleEnteredInCreateForm: e.target.value
        });
    }

    handleNewsEditTitleChange(e) {
        this.setState({
            titleEnteredInEditForm: e.target.value
        });
    }

    handleNewsCreateBodyChange(value) {
        if (value !== this.state.bodyEnteredInCreateForm) {
            this.setState({
                bodyEnteredInCreateForm: value
            });
        }
    }

    handleNewsEditBodyChange(value) {
        if (value !== this.state.bodyEnteredInEditForm) {
            this.setState({
                bodyEnteredInEditForm: value
            });
        }
    }

    render() {
        if (!this.props.loggedStatus.loggedIn) {
            return (
                <Redirect to='/' />
            );
        }


        return (
            <>
                <Navbar pageTitle="News and Updates" />
                <div className="container mt-3" style={{ paddingTop: "15px" }}></div>
                <Container fluid>
                    <Paper withBorder p="md" radius="md" m="5px">
                        <Row style={{marginBottom: "30px"}}>
                            <Col>
                                <div style={{ textAlign: "left" }}>
                                    {/* {this.props.userPermissions.can_alter_news_and_patch_notes ? */}
                                        <Select 
                                            data={
                                                this.state.products && this.state.products.map((product) => (
                                                    product.product_name
                                                ))
                                            } 
                                            label="Product" 
                                            value={this.state.productToDisplay} 
                                            onChange={(e) => this.handleProductChange(e)}
                                            allowDeselect={false}
                                        />
                                        {/* :
                                        "Cumulus News and Patch Notes"
                                    } */}
                                </div>
                            </Col>
                            <Col>
                                <div>
                                    <DateInput label="From" value={this.state.startDateSelected !== null ? this.state.startDateSelected : ""} onChange={(e) => this.handleStartDateChange(e)}/>
                                </div>
                            </Col>
                            <Col>
                                <div>
                                    <DateInput label="To" value={this.state.endDateSelected !== null ? this.state.endDateSelected : ""} onChange={(e) => this.handleEndDateChange(e)}/>
                                </div>
                            </Col>
                        </Row>
                        {this.props.userPermissions.can_alter_news_and_patch_notes ? 
                            <Row style={{marginBottom: "15px"}}>
                                <Col style={{textAlign: "right"}}>
                                    <Button onClick={() => this.openCreateNewsItemModal()}>Create New</Button>
                                </Col>    
                            </Row>
                            :
                            undefined
                        }
                        {this.state.notes && this.state.notes.map((note) => (
                            <Paper radius="md" bg={note.display_color/* note.type === "News" ? "var(--mantine-primary-color-filled)" : "orange" */} onClick={this.props.userPermissions.can_alter_news_and_patch_notes ? () => this.openEditNewsItemModal(note.id, note.associated_product_id, note.type, note.title, note.note_text) : undefined} shadow="sm" style={{marginBottom: "10px"}} key={`newsItem${note.id}`}>
                                <Paper withBorder radius="md" ml="sm" p="lg" pos="relative">
                                    <Title order={2} style={{cursor: "default"}}>{note.title}</Title>
                                    <Text c="dimmed" size="sm" style={{marginBottom: "20px", cursor: "default"}}>{`Posted By: ${note.first_name} ${note.last_name} - ${note.date_time_created.split(" ")[0]}`}</Text>
                                    <Text style={{cursor: "default"}}>{parse(cleanHTML(note.note_text))}</Text>
                                </Paper>
                            </Paper> 
                        ))}
                    </Paper>

                </Container>

                {/* This modal is for the create news or patch note process */}
                <Modal
                    opened={this.state.show_create_news_item_modal}
                    onClose={() => this.closeCreateNewsItemModal()}
                    //title="Let's Start With the Following Data"
                    size="xl"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Create a News Item</Text></div>
                        <Form.Row>
                            <Form.Group as={Col} controlId="createNewsItemProduct" required>
                                <Select 
                                    data={
                                        this.state.products && this.state.products.map((product) => (
                                            product.product_name
                                        ))
                                    } 
                                    label="Product" 
                                    value={this.state.productToSaveUnder} 
                                    onChange={(e) => this.handleProductToSaveChange(e)}
                                    allowDeselect={false}
                                />
                            </Form.Group>
                            <Form.Group as={Col} controlId="createNewsItemType" required>
                                <Select 
                                    data = {[
                                        "News",
                                        "Patch Note"
                                    ]}
                                    label="Type"
                                    value={this.state.typeChosenInCreateForm}
                                    onChange={(e) => this.handleNewsCreateTypeChange(e)}
                                    allowDeselect={false}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="createNewsItemTitle" required>
                                <TextInput 
                                    label="Title"
                                    placeholder="Input title here"
                                    value={this.state.titleEnteredInCreateForm}
                                    onChange={(e) => this.handleNewsCreateTitleChange(e)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="createNewsItemBody" required>
                                <Form.Label className="gothamNarrowFont">Message Body</Form.Label>
                                <div data-text-editor="name">
                                    <RichTextInput value={this.state.bodyEnteredInCreateForm} onChange={(e) => this.handleNewsCreateBodyChange(e)}/>
                                </div>
                            </Form.Group>
                        </Form.Row>
                        {/* <Form.Group as={Col} controlId="addContractFormCreateVendorName" required>
                            <TextInput label="Customer Name" placeholder="Enter Value Here" value={this.state.create_customer_name_entered} onChange={(e) => this.handleCreateCustomerNameChange(e.target.value)} />
                        </Form.Group> */}
                    </Form>
                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                        {this.state.canSeeErrorMessageCreateNewsItem ?
                            <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                            :
                            undefined
                        }
                    </div>
                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeCreateNewsItemModal()}>Cancel</Button></span>
                        <span><Button onClick={() => this.submitNewItem()}>Submit</Button></span>
                    </div>
                </Modal>

                {/* This modal is for the EDIT news or patch note process */}
                <Modal
                    opened={this.state.show_edit_news_item_modal}
                    onClose={() => this.closeEditNewsItemModal()}
                    //title="Let's Start With the Following Data"
                    size="xl"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                >
                    <Form>
                        <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Edit News Item</Text><Button
                            variant='transparent'
                            pos="absolute"
                            onClick={() => this.openDeleteNewsModal()}
                            right="10px"
                            top="10px"
                        ><IconTrash /></Button></div>
                        <Form.Row>
                            <Form.Group as={Col} controlId="editNewsItemProduct" required>
                                <Select 
                                    data={
                                        this.state.products && this.state.products.map((product) => (
                                            product.product_name
                                        ))
                                    } 
                                    label="Product" 
                                    value={this.state.productNameToEdit} 
                                    onChange={(e) => this.handleProductToEditChange(e)}
                                    allowDeselect={false}
                                />
                            </Form.Group>
                            <Form.Group as={Col} controlId="editNewsItemType" required>
                                <Select 
                                    data = {[
                                        "News",
                                        "Patch Note"
                                    ]}
                                    label="Type"
                                    value={this.state.typeChosenInEditForm}
                                    onChange={(e) => this.handleNewsEditTypeChange(e)}
                                    allowDeselect={false}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="editNewsItemTitle" required>
                                <TextInput 
                                    label="Title"
                                    placeholder="Input title here"
                                    value={this.state.titleEnteredInEditForm}
                                    onChange={(e) => this.handleNewsEditTitleChange(e)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="editNewsItemBody" required>
                                <Form.Label className="gothamNarrowFont">Message Body</Form.Label>
                                <div data-text-editor="name">
                                    <RichTextInput defaultValue={this.state.bodyEnteredInEditForm} onChange={(e) => this.handleNewsEditBodyChange(e)}/>
                                </div>
                            </Form.Group>
                        </Form.Row>
                        {/* <Form.Group as={Col} controlId="addContractFormCreateVendorName" required>
                            <TextInput label="Customer Name" placeholder="Enter Value Here" value={this.state.create_customer_name_entered} onChange={(e) => this.handleCreateCustomerNameChange(e.target.value)} />
                        </Form.Group> */}
                    </Form>
                    <div style={{ textAlign: "center", marginTop: "15px" }}>
                        {this.state.canSeeErrorMessageCreateNewsItem ?
                            <Text c="red">Error: One or more required form fields has not been filled out. Please complete required fields.</Text>
                            :
                            undefined
                        }
                    </div>
                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeEditNewsItemModal()}>Cancel</Button></span>
                        <span><Button onClick={() => this.submitEditItem()}>Submit</Button></span>
                    </div>
                </Modal>

                <Modal
                    opened={this.state.show_delete_news_modal}
                    onClose={() => this.closeDeleteNewsModal()}
                    //title="Let's Start With the Following Data"
                    size="xl"
                    centered
                    closeOnClickOutside={false}
                    withCloseButton={false}
                >
                    <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Are you sure you want to delete this item?</Text></div>
                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeDeleteNewsModal()}>Cancel</Button></span>
                        <span><Button color="red" onClick={() => this.deleteNewsItem()}>Delete</Button></span>
                    </div>
                </Modal>
            </>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        ticketRequester: state.ticketRequester,
        userPermissions: state.userPermissions
    };
}

export default connect(mapStateToProps, { LOGOUT })(NewsAndPatchNotes);